import { createTheme } from '@mui/material/styles';

// Custom dark blue palette
export const darkBlueTheme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // MUI's default blue
      dark: '#0d47a1', // Darker shade of blue
    },
    action: {
      selected: 'rgba(25, 118, 210, 0.5)',
      hover: 'rgba(25, 118, 210, 0.12)',
      focus: 'rgba(25, 118, 210, 0.3)',
    },
  },
  components: {
    MuiTouchRipple: {
      styleOverrides: {
        rippleVisible: {
          opacity: 0.8,
        }
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '& .MuiTouchRipple-rippleVisible': {
            opacity: 0.8,
          }
        },
        outlined: {
          borderColor: '#0d47a1',
          color: '#0d47a1',
          '&:hover': {
            borderColor: '#1976d2',
            backgroundColor: 'rgba(13, 71, 161, 0.14)',
          },
          '&.Mui-focusVisible': {
            borderWidth: '3px',
            borderColor: 'red',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&.Mui-focusVisible': {
            border: '3px solid red',
          },
          color: '#0d47a1',
          '&:hover': {
            backgroundColor: 'rgba(13, 71, 161, 0.14)',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(13, 71, 161, 0.14)',
          },
          '&.Mui-selected': {
            backgroundColor: '#0B437E',
            color: 'white !important',
          },
          '&.Mui-focusVisible': {
            border: '3px solid currentColor',
            backgroundColor: 'rgb(25, 118, 210, 0.3)',
          },
          '&.Mui-focusVisible.Mui-selected': {
            backgroundColor: 'rgb(25, 118, 210, 0.3)',
            color: 'black !important'
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'currentColor',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          '&.MuiSelect-icon': {
            color: 'currentColor',
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        icon: {
          color: 'currentColor',
        },
        root: {
          color: 'currentColor',
          '& .MuiSelect-icon': {
            color: 'currentColor',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          'forced-color-adjust': 'none',
          border: '2px solid white',
        },
        thumb: {
          border: '2px solid white',
          'forced-color-adjust': 'none',
        },
        switchBase: {
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            border: '3px solid red',
            overflow: 'visible',
          },
          '&.Mui-focusVisible .MuiSwitch-track': {
            border: '2px solid red',
          },
          '&.Mui-focusVisible': {
            '& .MuiTouchRipple-root': {
              opacity: 0,
            }
          },
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.14)'
          },
        },
      },
    },
    // @ts-ignore this exists through a plugin
    MuiDataGrid: {
      styleOverrides: {
        columnHeader: {
          '&:focus-within': {
            border: '2px solid black',
          },
        },
      },
    },
  },
}); 
